<pace-core-side-menu></pace-core-side-menu>
<pace-core-navigation-link></pace-core-navigation-link>
<pace-core-whats-new></pace-core-whats-new>
<div class="gid">
    <fa-icon [icon]="faUser"></fa-icon><span> {{ gid }}</span>
</div>
@if (displaySync) {
    <pace-core-sync-indicator></pace-core-sync-indicator>
}
